import { render, staticRenderFns } from "./youtube-video.vue?vue&type=template&id=04c3a029&lang=pug"
import script from "./youtube-video.vue?vue&type=script&lang=ts"
export * from "./youtube-video.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports